import {
  DarAddressFields,
  DarHusnummerFields,
  DarNavngivenVejFields,
  DarPostnummerFields
} from './types';

const DatafordererAllowedMethods = {
  DAR_Adresse: 'DAR_Adresse'
};

export default class DatafordelerHelper {
  static createDarAddressBody(id: string) {
    return `
      query {
        ${DatafordererAllowedMethods.DAR_Adresse} (
        where: {
          id_lokalId: {
            eq: "${id}"
          }
        }
        virkningstid: "${new Date().toISOString()}"
        registreringstid: "${new Date().toISOString()}"
        first: 1
        ) {
        nodes {
          ${Object.keys(DarAddressFields).join('\n')}
          adresseHarHusnummer {
            ${Object.keys(DarHusnummerFields).join('\n')}
            husnummerHoererTilIPostnummer {
              ${Object.keys(DarPostnummerFields).join('\n')}
            }
            husnummerHoererTilNavngivenVej {
              ${Object.keys(DarNavngivenVejFields).join('\n')}
            }
          }
        }
      }
    }`;
  }
}
